import { PncRiskPresentationFrontComponent } from './risk-presentation/pnc-risk-presentation-front.component';
import { PncRiskPresentationBackComponent } from './risk-presentation/pnc-risk-presentation-back.component';

import { PncRiskReviewFrontComponent } from './risk-review/pnc-risk-review-front.component';
import { PncRiskReviewBackComponent } from './risk-review/pnc-risk-review-back.component';

export const PncComponentTemplates = {
  riskReview: {
    front: PncRiskReviewFrontComponent,
    back: PncRiskReviewBackComponent,
  },
  riskPresentation: {
    front: PncRiskPresentationFrontComponent,
    back: PncRiskPresentationBackComponent,
  },
};
